/*
 * Renders the TechEdge button which calls the TechEdge modal.
 */

angular
  .module('app.components')
  .directive('techedge',
  ['ModalService',
  ModalService => ({
    restrict: 'A',
    scope: {
      campaign: '='
    },
    controller: ['$scope', $scope => {
      $scope.openTechEdgeModal = () => {
        ModalService.showModal({
          templateUrl: `/assets/js/app/components/techEdge/techEdge.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'TechEdgeModalController',
          controllerAs: 'techEdgeModal',
          inputs: {
            addSnapshot: false,
            saveFromModal: true,
            targetCampaign: $scope.campaign,
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            $('.modal-backdrop.fade.in').remove();
          });
        });
      };
    }],
    template: `
      <a tabindex="-1" href="" ng-click="openTechEdgeModal()">
        <span class="icon primary duplicate"></span>Send to TechEdge
      </a>`,
  })]);
